import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Alert, Form, Icon, Input, Modal, message, Button } from 'antd'
import { login as actionLogin } from '../../redux-flow/actions/login'
import Navbar from '../../Components/Navbar'
import Footer from '../../Components/Footer'
import { request } from '../../utils/api'
import {
    infoRequired,
    validateEmail
} from '../../utils/validators'
import './login.css'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import CookieConsentComponent from '../../Components/CookieConsent'
import theme from '../../config/theme'

const mapStateToProps = state => ({
    logged: state.login.logged,
    message: state.login.logMessage,
    isLoading: state.login.isLoading
})

const mapDispatchToProps = dispatch => ({
    handleSubmit: form => e => {
        e.preventDefault()
        dispatch(actionLogin(form))
    }
})


const MyForm = Form.create({ name: 'login-form' })(
    connect(mapStateToProps, mapDispatchToProps)(
        ({ form, handleSubmit, message, isLoading, logged, onEsqueciSenha, onReenviarEmail }) => (
            
                <Form className="loginForm" layout="vertical" onSubmit={handleSubmit(form)}>
                    {message && <Form.Item>
                        <Alert message={message} type="error" showIcon />
                    </Form.Item>}

                    <div style={{ textAlign: 'center' }}>
                        {isLoading && <Form.Item>
                            <Icon type="loading" />
                        </Form.Item>}
                    </div>

                    <Form.Item label="E-mail">
                        {form.getFieldDecorator('email', {
                            rules: [ infoRequired, validateEmail() ]
                        })(
                            <Input type="email" placeholder="E-mail" />
                        )}
                    </Form.Item>
                    <div className="reenviarEmailBtn">
                        <span className="text-white font-weight-bold" onClick={onReenviarEmail}>Reenviar e-mail de confirmação</span>
                    </div>

                    <Form.Item label="Senha" className="mt-5">
                        {form.getFieldDecorator('password', {
                            rules: [ infoRequired ]
                        })(
                            <Input.Password placeholder="Senha" />
                        )}
                    </Form.Item>

                    <div className="esqueciSenhaBtn">
                        <span className="text-white font-weight-bold" onClick={onEsqueciSenha}>Esqueceu sua senha?</span>
                    </div>  
                    
                    <Form.Item className="loginFooter mt-3">
                        <button 
                            disabled={isLoading} 
                            type="submit"
                            style={{
                                backgroundColor: theme.colors.primary,
                                color: theme.colors.white,
                                border: 'none',
                                padding: '8px 24px',
                                borderRadius: '4px',
                                cursor: 'pointer'
                            }}
                        >
                            Entrar
                        </button>
                    </Form.Item>
                </Form>
            
        )
    )
)

class Login extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            modal: false,
            loading: false,
            success: false,
            email: '',
            fillBackground: false,
        }
    }

    componentDidMount() {
        window.scrollTo(0,0);
        window.addEventListener('scroll', this.handleWindowScroll, true)
    }

    handleChange = e => {
        this.setState({
            email: e.target.value
        })
    }

    closeModal = () => {
        this.setState({
            modal: false,
            loading: false,
            success: false,
            email: ''
        })
    }

    openModal = () => {
        this.setState({
            modal: true
        })
    }

    showEmailForm = () => {
        this.setState({
            modalEmail: true
        })
    }

    closeEmailModal = () => {
        this.setState({
            modalEmail: false,
            loading: false,
            success: false,
            email: ''
        })
    }

    requestReset = async () => {
        if (!(this.state.loading || this.state.success)) {
            this.setState({ loading: true })
            try {
                const { code, message: errMessage } = await request('users/request-reset-password/' + this.state.email)
                if (code === 200) {
                    this.setState({
                        loading: false,
                        success: true
                    })
                } else {
                    message.error(errMessage || 'Ops! Não conseguimos enviar o e-mail!')
                }
            } catch(e) {
                this.setState({
                    loading: false,
                    success: false
                })
            }
        }
    }

    requestEmail = async () => {
        if(!(this.state.loading || this.state.success)) {
            this.setState({ loading: true })
            try {
                const { code, message: errMessage } = await request('users/request-email/' + this.state.email)
                if(code === 200) {
                    this.setState({
                        loading: false,
                        success: true
                    })
                } else {
                    this.setState({
                        loading: false,
                        success: false
                    })
                    message.error(errMessage || 'Ops! Não conseguimos enviar o e-mail!')
                }
            } catch(e) {
                // console.log(e)
                this.setState({
                    loading: false,
                    success: false
                })
            }
        }
    }

    handleWindowScroll = () => {
        this.setState({
            fillBackground: window.scrollY > 100
        })
    }

    render() {
        return (
            <div id="sectionLogin">
                <Navbar  fillBackground={this.state.fillBackground} />
                    <div className="section loginSection">
                        <Container className="h-100">
                            <Row className="h-100">
                                <Col md={12} className="d-flex align-items-center justify-content-center">
                                    <div className="loginWrapper d-flex flex-column align-items-center">
                                        <img alt="Logo" src={theme.logos.icon} className="img-fluid" />
                                        <h6 className="subTitle text-white">Acesse sua conta</h6>
                                        <MyForm onEsqueciSenha={this.openModal}  onReenviarEmail={this.showEmailForm} />
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                    <CookieConsentComponent />
                <Footer />
                <Modal
                    visible={this.state.modal}
                    onCancel={this.closeModal}
                    okText="Sim"
                    cancelText="Não"
                    onOk={this.requestReset}
                    {...{
                        footer: (this.state.success || this.state.loading)
                            ? <Button disabled={this.state.loading} onClick={this.closeModal}>Fechar</Button>
                            : undefined
                    }}
                >
                    <div>
                        <div style={{ alignItems: 'center', display: 'flex', maxWidth: 960, margin: 'auto', justifyContent: 'center' }}>
                            <div style={{ display: 'flex', flex: 1, fontSize: '6em', justifyContent: 'center', alignItems: 'center' }}>
                                <Icon type={
                                    this.state.loading ? 'loading'
                                        : this.state.success ?
                                            'check-circle'
                                            : 'mail'
                                }/>
                            </div>
                            <div style={{ flex: 2 }}>
                                <h2>Esqueceu sua senha?</h2>
                                <p>
                                    {
                                        this.state.loading ?
                                        'Aguarde... Estamos lhe enviando um e-mail de solicitação de recuperação de senha.'
                                        : this.state.success ? 'Pronto! Enviamos um e-mail de recuperação de senha! Lembre-se de verificar sua caixa de Lixo Eletrônico para ter certeza de que recebeu o e-mail!' :
                                            'Informe seu e-mail e clique em "Sim", e iremos lhe enviar um e-mail de recuperação de senha!'
                                    }
                                </p>
                            </div>
                        </div>
                        <div>
                            <Input disabled={this.state.success || this.state.loading} type="email" placeholder="E-mail" onChange={this.handleChange} />
                        </div>
                    </div>
                </Modal>

                <Modal
                    visible={this.state.modalEmail}
                    onCancel={this.closeEmailModal}
                    onOk={this.requestEmail}
                    okText="Sim"
                    cancelText="Não"
                    {...{
                        footer: (this.state.success || this.state.loading)
                            ? <Button disabled={this.state.loading} onClick={this.closeEmailModal}>Fechar</Button>
                            : undefined
                    }}
                >
                    <div>
                        <div style={{ alignItems: 'center', display: 'flex', maxWidth: 960, margin: 'auto', justifyContent: 'center' }}>
                            <div style={{ display: 'flex', flex: 1, fontSize: '6em', justifyContent: 'center', alignItems: 'center' }}>
                                <Icon type={
                                    this.state.loading ? 'loading'
                                        : this.state.success ?
                                            'check-circle'
                                            : 'mail'
                                }/>
                            </div>
                            <div style={{ flex: 2 }}>
                                <h2>Reenviar e-mail de confirmação</h2>
                                <p>
                                    {
                                        this.state.loading ?
                                        'Aguarde... Estamos reenviando o e-mail de confirmação de conta.'
                                        : this.state.success ? 'Pronto! Reenviamos o e-mail de confirmação de conta! Lembre-se de verificar sua caixa de Lixo Eletrônico para ter certeza de que recebeu o e-mail!' :
                                            'Informe seu e-mail e clique em "Sim", e iremos reenviar o e-mail de confirmação de conta!'
                                    }
                                </p>
                            </div>
                        </div>
                        <div>
                            <Input disabled={this.state.success || this.state.loading} type="email" placeholder="E-mail" onChange={this.handleChange} />
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}

export default Login